var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    stroke: "#E2ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 26V23H12V26H26ZM26 21V17H12V21H26ZM26 15V12H12V15H26ZM12 28C11.45 28 10.979 27.8043 10.587 27.413C10.1957 27.021 10 26.55 10 26V12C10 11.45 10.1957 10.979 10.587 10.587C10.979 10.1957 11.45 10 12 10H26C26.55 10 27.021 10.1957 27.413 10.587C27.8043 10.979 28 11.45 28 12V26C28 26.55 27.8043 27.021 27.413 27.413C27.021 27.8043 26.55 28 26 28H12Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/tableIcon.60ac5310e92132dae76418f78445cbfb.svg";
export { ForwardRef as ReactComponent };